import axiosClient from "utils/api";

export const getMe = async () => {
  try {
    const response = await axiosClient().request({
      url: "/admin/auth/profile",
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error at Get ME Service", error);
    throw error;
  }
};

export const updateMe = async (payload) => {
  try {
    const response = await axiosClient().request({
      url: `/admin/auth/profile`,
      method: "put",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error at Update Account Service", error);
    throw error;
  }
};

export const changePassword = async (payload) => {
  try {
    const response = await axiosClient().request({
      url: "/admin/auth/changePassword",
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error at Change Password Service", error);
    throw error;
  }
};